module.exports = __webpack_public_path__ + "static/media/vetricle.a253ff5f.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/vetricle.PNG
// module id = 88
// module chunks = 0